export default __webpack_public_path__ + "static/media/bg-mobile.53bcc968.png";